export default __webpack_public_path__ + "static/media/redis.52a85440.png";